import React, { Component } from 'react'
import { Grid, Row, Col } from 'react-bootstrap'
import { Helmet } from 'react-helmet'
import { getInitialData } from '../../helpers'
import Footer from '../Static/Footer'

import ActiveCitizen from '../Static/logos/activeCitizen'
import Osf from '../Static/logos/osf'
import Kultury from '../Static/logos/kultury'
import Sloboda from '../Static/logos/sloboda'
import Rtv from '../Static/logos/rtv'

import './partneri.sass'

class About89 extends Component {
  constructor(props) {
    super(props)
    this.content = getInitialData('partneri89')
  }

  render() {
    return (
      <Grid className="partneri-page static-page">
        <Helmet>
          <title>Partneri - SPÝTAJ SA VAŠICH 89</title>
        </Helmet>
        <Row>
          <Col xs={12}>
            <h1>Partneri</h1>
          </Col>
        </Row>
        <Row>
          <Col className="content" md={4}>
            <div className="card" dangerouslySetInnerHTML={{ __html: this.content }} />
            <Footer is89 />
          </Col>
          <Col md={8}>
            <p>Projekt vznikol s finančnou podporou:</p>
            <ul className="partner-logos">
              <li className="active-citizen"><ActiveCitizen /></li>
              <li className="osf"><Osf /></li>
              <li className="kultury"><Kultury /></li>
            </ul>

            <p>Hlavný partner:</p>
            <ul className="partner-logos">
              <li className="sloboda"><Sloboda /></li>
            </ul>

            <p>Mediálny partner:</p>
            <ul className="partner-logos">
              <li className="rtv"><Rtv /></li>
            </ul>

            <p>Ďakujeme za spoluprácu:</p>
            <ul className="partner-logos">
              <li className="upn"><img src="../images/upn.png" alt="" /></li>
            </ul>
          </Col>
        </Row>
      </Grid>
    )
  }
}

export default About89



// WEBPACK FOOTER //
// ./src/components/89/Partneri89.js